const TOKEN_KEY = 'token';

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(newToken: string): void {
  localStorage.setItem(TOKEN_KEY, newToken);
}

export function deleteToken(): void {
  return localStorage.removeItem(TOKEN_KEY);
}

export function emptyLocalStorage(): void {
  return localStorage.clear();
}
